import { useState } from "react";
import { FaSearch, FaUtensils } from "react-icons/fa";
import CartSummaryBar from "../components/CartSummaryBar";
import CategoryChips from "../components/CategoryChips";
import CustomerMenuHeader from "../components/CustomerMenuHeader";
import MenuIntro from "../components/MenuIntro";
import MenuItemCard from "../components/MenuItemCard";
import MenuSidebar from "../components/MenuSidebar";
import MenuSplash from "../components/MenuSplash";
import BamizbanBadge from "../components/BamizbanBadge";

const ClassicMenuTheme = (props) => {
  const {
    menuData,
    restaurant,
    settings,
    profileImage,
    coverImage,
    categories,
    visibleItems,
    activeCategoryKey,
    setActiveCategoryKey,
    searchTerm,
    setSearchTerm,
    quantities,
    cartSummary,
    addItem,
    decreaseItem,
    openItem,
    openCart,
    showBamizbanBadge,
  } = props;
  const [infoOpen, setInfoOpen] = useState(false);
  const [navigationOpen, setNavigationOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 pb-24" dir="rtl">
      <MenuSplash
        restaurantName={restaurant.name || menuData.title}
        profileImage={profileImage}
        backgroundColor="#F88225"
        accentColor="rgba(255,255,255,0.75)"
        tagline="لذت غذای خوب"
      />
      <CustomerMenuHeader restaurantName={restaurant.name} profileImage={profileImage} onInfo={() => setInfoOpen(true)} onMenu={() => setNavigationOpen(true)} />
      <section className="relative h-40 overflow-hidden bg-gray-200 sm:h-52">
        <img src={coverImage} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 mx-auto max-w-5xl px-4 pb-4 text-white">
          <p className="text-xl font-black sm:text-2xl">{menuData.title}</p>
          {settings.openingHours && <p className="mt-1 text-xs text-white/90">ساعات کاری: {settings.openingHours}</p>}
        </div>
      </section>

      <div className="sticky top-16 z-30 border-b border-gray-100 bg-gray-50/95 backdrop-blur">
        <div className="mx-auto max-w-5xl px-4 pt-3">
          <label className="relative block"><span className="sr-only">جست‌وجوی منو</span><FaSearch className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" /><input type="search" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} placeholder="جست‌وجوی غذا و نوشیدنی" className="min-h-12 w-full rounded-xl border border-gray-200 bg-white py-3 pl-4 pr-11 outline-none focus:border-primary focus:ring-2 focus:ring-primary/20" /></label>
        </div>
        <CategoryChips categories={categories} activeKey={activeCategoryKey} onChange={setActiveCategoryKey} />
      </div>

      <main className="mx-auto max-w-5xl px-4 py-5">
        {visibleItems.length ? (
          <div className="grid gap-3 md:grid-cols-2">
            {visibleItems.map((item) => <MenuItemCard key={item._id} item={item} quantity={quantities[item._id]} onAdd={addItem} onDecrease={decreaseItem} onClick={openItem} />)}
          </div>
        ) : (
          <div className="rounded-2xl border border-dashed border-gray-200 bg-white px-4 py-14 text-center"><FaUtensils className="mx-auto text-3xl text-gray-300" /><p className="mt-3 font-bold text-gray-800">آیتمی پیدا نشد</p><p className="mt-1 text-sm text-gray-500">عبارت جست‌وجو یا دسته‌بندی را تغییر دهید.</p>{searchTerm && <button type="button" onClick={() => { setSearchTerm(""); setActiveCategoryKey("all"); }} className="mt-4 text-sm font-bold text-primary">پاک کردن جست‌وجو</button>}</div>
        )}
      </main>

      {showBamizbanBadge && <BamizbanBadge />}
      <CartSummaryBar {...cartSummary} onOpen={openCart} />
      <MenuIntro open={infoOpen} restaurantData={restaurant} profileImage={profileImage} onClose={() => setInfoOpen(false)} />
      {navigationOpen && <MenuSidebar onClose={() => setNavigationOpen(false)} />}
    </div>
  );
};

export default ClassicMenuTheme;
